import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'payroll_recs_do_not_show_all_the_types_of_social_insurance_the'

export const dataPointDefinition = {
  retracedId: 'payroll_recs_do_not_show_all_the_types_of_social_insurance_the',
  name: 'Payroll records do not show all the types of social insurance the workers are paid',
  description:
    'The intent of this option selection is to understand if records reflect the types of social insurance/ social security the workers are provided. Payroll records should be consistent with the types of social insurance/ social security listed under the category Social Insurance / Social Security in this Wages & Benefits section. \r\r\n\r\r\nFor example, if the facility provides social insurance/ social security to workers and payroll records only show some (not all) types of social insurance/ social security the workers are provided, this item should NOT be selected.\r\r\n\r\r\nIf the facility does not provide social insurance/ social security to workers, select Not Applicable.',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'X',
      key: 'TRUE',
      slcpIndex: 1,
      slcpOptionName: 'xna',
    },
    {
      name: 'Not Applicable',
      key: 'NOT_APPLICABLE',
      slcpIndex: 2,
      slcpOptionName: 'xna',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['TRUE', 'NOT_APPLICABLE'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-wage-1',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 7270,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
